// Centralised site content for Nexora Technologies
export const BRAND = {
  name: "Nexora Technologies",
  tagline: "The European AI Transformation Partner",
  logoUrl:
    "https://customer-assets.emergentagent.com/job_9df38aed-6981-458d-8448-95dadfb91f01/artifacts/qxdkj63j_logo_nexora.png",
};

export const COUNTRIES = [
  { code: "nl", name: "Netherlands", flag: "🇳🇱", path: "/countries/netherlands", lang: "en" },
  { code: "de", name: "Germany", flag: "🇩🇪", path: "/countries/germany", lang: "de" },
  { code: "ch", name: "Switzerland", flag: "🇨🇭", path: "/countries/switzerland", lang: "en" },
  { code: "be", name: "Belgium", flag: "🇧🇪", path: "/countries/belgium", lang: "en" },
  { code: "uk", name: "United Kingdom", flag: "🇬🇧", path: "/countries/united-kingdom", lang: "en" },
];

export const SKILLS = [
  { slug: "ai-engineers", label: "AI Engineers" },
  { slug: "generative-ai", label: "Generative AI Specialists" },
  { slug: "ml-engineers", label: "Machine Learning Engineers" },
  { slug: "mlops", label: "MLOps Engineers" },
  { slug: "data-engineers", label: "Data Engineers" },
  { slug: "data-scientists", label: "Data Scientists" },
  { slug: "cloud-engineers", label: "Cloud Engineers (Azure / AWS / GCP)" },
  { slug: "cloud-architects", label: "Cloud Architects" },
  { slug: "devops", label: "DevOps Engineers" },
  { slug: "cybersecurity", label: "Cybersecurity Specialists" },
  { slug: "sap", label: "SAP Consultants" },
  { slug: "software-dev", label: "Software Development Teams" },
  { slug: "java", label: "Java Developers" },
  { slug: "dotnet", label: ".NET Developers" },
  { slug: "python", label: "Python Developers" },
  { slug: "fullstack", label: "Full Stack Developers" },
  { slug: "power-platform", label: "Microsoft Power Platform" },
  { slug: "salesforce", label: "Salesforce Consultants" },
  { slug: "transformation", label: "Technology Transformation Consulting" },
];

export const TEAM_SIZES = [
  { slug: "1-3", label: "1 – 3 specialists" },
  { slug: "4-6", label: "4 – 6 specialists" },
  { slug: "7-10", label: "7 – 10 specialists" },
  { slug: "10-plus", label: "10+ specialists" },
];

export const DURATIONS = [
  { slug: "3m", label: "3 months" },
  { slug: "6m", label: "6 months" },
  { slug: "12m", label: "12 months" },
  { slug: "ongoing", label: "Ongoing partnership" },
];

export const HOMEPAGE_DELIVERABLES = [
  "AI Engineers",
  "Generative AI Specialists",
  "Machine Learning Engineers",
  "Cloud Engineers",
  "Cybersecurity Experts",
  "DevOps Engineers",
  "Data Engineers",
  "SAP Consultants",
  "Software Development Teams",
  "Technology Transformation Consulting",
];

export const TRUST_STATS = [
  { value: "20+", label: "Years of international delivery" },
  { value: "5", label: "European markets served" },
  { value: "500+", label: "Specialists deployed" },
  { value: "<1h", label: "Average response time" },
];

export const SERVICES = [
  {
    slug: "ai-transformation",
    title: "AI Transformation",
    summary:
      "Identify, design and operationalise AI use cases with measurable business value — from strategy to deployment.",
    bullets: ["AI Strategy & Roadmap", "Generative AI Solutions", "AI Governance", "AI Centre of Excellence"],
  },
  {
    slug: "dedicated-teams",
    title: "Dedicated Engineering Teams",
    summary:
      "Senior nearshore engineering pods that plug directly into your delivery — same time zone, European standards.",
    bullets: ["Pod-based delivery", "Senior-led teams", "Transparent governance", "Flexible scaling"],
  },
  {
    slug: "cloud",
    title: "Cloud Engineering",
    summary:
      "Azure, AWS and GCP architecture, migration and FinOps — built for European compliance and resilience.",
    bullets: ["Landing zones", "Cloud migration", "Platform engineering", "FinOps"],
  },
  {
    slug: "cybersecurity",
    title: "Cybersecurity",
    summary:
      "From zero-trust architecture to OT security — protect your enterprise across every layer.",
    bullets: ["Zero-trust design", "Cloud security", "Identity & access", "OT / IoT security"],
  },
  {
    slug: "sap",
    title: "SAP & Enterprise Platforms",
    summary:
      "S/4HANA, BTP and enterprise modernisation programmes delivered by certified senior consultants.",
    bullets: ["S/4HANA migration", "BTP development", "Integration", "Managed services"],
  },
  {
    slug: "software-engineering",
    title: "Software Engineering",
    summary:
      "Full-lifecycle product engineering — discovery, design, build and modernise — with European quality.",
    bullets: ["Product engineering", "Platform modernisation", "QA & DevOps", "API platforms"],
  },
];

export const AI_SERVICES = [
  { title: "AI Strategy", desc: "Define the highest-value AI initiatives aligned to your business strategy." },
  { title: "AI Readiness Assessment", desc: "Evaluate data, talent, infrastructure and governance readiness." },
  { title: "AI Governance", desc: "Operate AI responsibly with policies, controls and EU AI Act alignment." },
  { title: "AI Factory Advisory", desc: "Design a repeatable delivery model that scales AI from PoC to production." },
  { title: "Generative AI Solutions", desc: "Build copilots, agents and knowledge systems on your enterprise data." },
  { title: "AI Automation", desc: "Automate complex workflows by combining LLMs, RPA and process intelligence." },
  { title: "AI Integration", desc: "Integrate AI into your core systems — CRM, ERP, data platforms and beyond." },
  { title: "AI Infrastructure Advisory", desc: "Architect GPU, MLOps and platform foundations for production AI." },
  { title: "AI Training", desc: "Upskill leaders and engineers with role-based AI programmes." },
  { title: "AI Centre of Excellence", desc: "Stand up a CoE that orchestrates AI value across the enterprise." },
];

export const INDUSTRIES = [
  { slug: "financial-services", title: "Financial Services", desc: "Banking, insurance and capital markets." },
  { slug: "government", title: "Government & Public Sector", desc: "Digital public services and sovereign cloud." },
  { slug: "healthcare", title: "Healthcare & Life Sciences", desc: "Clinical, research and pharma transformation." },
  { slug: "energy", title: "Energy & Utilities", desc: "Energy transition, grid intelligence, OT security." },
  { slug: "manufacturing", title: "Manufacturing", desc: "Industry 4.0, smart factories, supply chain AI." },
  { slug: "retail", title: "Retail & E-commerce", desc: "Omnichannel, personalisation and demand AI." },
  { slug: "logistics", title: "Logistics & Transport", desc: "Networks, routing intelligence and digital twins." },
  { slug: "telecom", title: "Telecommunications", desc: "Network modernisation and customer AI." },
];

export const LEADERSHIP_PRINCIPLES = [
  {
    title: "Senior-led engagements",
    desc: "Every programme is led by senior engineers and advisors — not junior resources behind a brand.",
  },
  {
    title: "European standards",
    desc: "GDPR-native delivery, EU AI Act-aligned governance and a nearshore model in the same business hours.",
  },
  {
    title: "Outcome over hours",
    desc: "We commit to measurable outcomes, not just timesheets. Our pods are accountable end-to-end.",
  },
  {
    title: "Transparent governance",
    desc: "Open delivery dashboards, weekly steering rituals, full visibility into velocity and risk.",
  },
];

// ---------- Country-specific data ----------
export const COUNTRY_DATA = {
  netherlands: {
    code: "nl",
    name: "Netherlands",
    flag: "🇳🇱",
    lang: "en",
    hero: {
      eyebrow: "Netherlands",
      title: "Technology Talent for the Netherlands",
      lede: "The Dutch technology market is growing faster than available talent. We help organisations rapidly scale their technology teams with highly experienced professionals working in almost the same time zone.",
      body: "Whether you are building AI solutions, migrating to Azure, modernising SAP or strengthening your cybersecurity posture, we provide the right specialists exactly when you need them.",
    },
    specialists: [
      "AI Engineers",
      "Azure Cloud Engineers",
      "Cybersecurity Specialists",
      "DevOps Engineers",
      "Data Engineers",
      "Microsoft Power Platform Specialists",
      "SAP Consultants",
      "Java Developers",
      "Full Stack Developers",
      "Data Analysts",
    ],
    industries: ["Financial Services", "Government", "Healthcare", "Energy", "Logistics", "Retail", "Manufacturing"],
    whyUs: [
      "Nearshore collaboration",
      "Minimal time difference",
      "Rapid onboarding",
      "Dedicated teams",
      "Flexible scaling",
      "20+ years international delivery experience",
    ],
  },
  germany: {
    code: "de",
    name: "Deutschland",
    flag: "🇩🇪",
    lang: "de",
    hero: {
      eyebrow: "Deutschland",
      title: "IT-Spezialisten für den deutschen Markt",
      lede: "Der Fachkräftemangel muss Ihr Wachstum nicht bremsen. Unsere Nearshore-Teams integrieren sich nahtlos in Ihre Organisation und liefern höchste Qualität.",
      body: "Ob KI, Cloud-Migration, SAP-Modernisierung oder Cybersecurity — wir liefern die richtigen Expertinnen und Experten genau dann, wenn Sie sie benötigen.",
    },
    specialistsHeading: "Die meistgesuchten Experten",
    specialists: [
      "SAP S/4HANA Berater",
      "KI Engineers",
      "Cybersecurity Spezialisten",
      "Cloud Architekten",
      "DevOps Engineers",
      "Embedded Software Engineers",
      "Data Engineers",
      "Java Entwickler",
      "Platform Engineers",
      "OT Security Spezialisten",
    ],
    industriesHeading: "Branchen",
    industries: ["Automotive", "Manufacturing", "Finance", "Healthcare", "Energy", "Government"],
    whyHeading: "Warum Nexora?",
    whyUs: [
      "Nearshore Zusammenarbeit",
      "Minimaler Zeitunterschied",
      "Schnelles Onboarding",
      "Dedizierte Teams",
      "Flexible Skalierung",
      "20+ Jahre internationale Erfahrung",
    ],
    formHeading: "Lassen Sie uns Ihren Wettbewerbsvorteil aufbauen",
    formLede: "Erzählen Sie uns, welche Profile Sie suchen — wir melden uns innerhalb eines Werktages.",
  },
  switzerland: {
    code: "ch",
    name: "Switzerland",
    flag: "🇨🇭",
    lang: "en",
    hero: {
      eyebrow: "Switzerland",
      title: "Technology Excellence for Switzerland",
      lede: "Swiss organisations demand world-class technology expertise. Our specialists deliver enterprise-grade solutions while collaborating in almost identical business hours.",
      body: "From private banking to pharmaceutical R&D, we deliver the senior technologists Swiss enterprises rely on.",
    },
    specialists: [
      "AI Engineers",
      "Quant Developers",
      "Cloud Security Engineers",
      "Cybersecurity Specialists",
      "Azure Architects",
      "DevSecOps Engineers",
      "Data Engineers",
      "MLOps Engineers",
      "Software Architects",
      "Blockchain Engineers",
    ],
    industries: ["Banking", "Insurance", "Life Sciences", "Pharmaceuticals", "Healthcare", "Manufacturing"],
    whyUs: [
      "Senior-led teams",
      "Swiss-grade quality",
      "Same-day collaboration",
      "Sovereign data handling",
      "Regulated industry experience",
      "20+ years international delivery experience",
    ],
  },
  belgium: {
    code: "be",
    name: "Belgium",
    flag: "🇧🇪",
    lang: "en",
    hero: {
      eyebrow: "Belgium",
      title: "Technology Talent that Accelerates Innovation",
      lede: "Finding experienced IT professionals has never been more difficult. Our nearshore teams provide immediate capacity while maintaining European quality standards.",
      body: "From the European institutions in Brussels to financial services and life sciences — Nexora delivers across Belgium's most demanding sectors.",
    },
    specialists: [
      "Azure Engineers",
      "SAP Consultants",
      "Cybersecurity Specialists",
      "Data Engineers",
      "Java Developers",
      ".NET Developers",
      "DevOps Engineers",
      "AI Engineers",
      "Business Intelligence Specialists",
      "Cloud Operations Engineers",
    ],
    industries: ["European Institutions", "Financial Services", "Chemicals", "Logistics", "Healthcare", "Government"],
    whyUs: [
      "Bilingual collaboration",
      "EU-grade compliance",
      "Senior delivery teams",
      "Flexible scaling",
      "Brussels & Antwerp focus",
      "20+ years international delivery experience",
    ],
  },
  "united-kingdom": {
    code: "uk",
    name: "United Kingdom",
    flag: "🇬🇧",
    lang: "en",
    hero: {
      eyebrow: "United Kingdom",
      title: "World-Class Technology Talent for UK Organisations",
      lede: "Scale faster with highly experienced technology specialists. We provide dedicated engineering teams with minimal time difference and seamless collaboration.",
      body: "From FinTech in London to defence and energy programmes nationwide — Nexora delivers senior-led engineering teams at UK quality bar.",
    },
    specialists: [
      "AI Engineers",
      "Cybersecurity Specialists",
      "Cloud Engineers",
      "DevOps Engineers",
      "Data Scientists",
      "Python Developers",
      "Java Developers",
      "Salesforce Consultants",
      "AWS Architects",
      "Platform Engineers",
    ],
    industries: ["Financial Services", "FinTech", "Healthcare", "Retail", "Defence", "Energy", "Telecommunications"],
    whyUs: [
      "Same-day collaboration",
      "Senior-led pods",
      "UK quality standards",
      "Rapid onboarding",
      "Flexible scaling",
      "20+ years international delivery experience",
    ],
  },
};

export const FOOTER_LINKS = {
  company: [
    { label: "About", path: "/about" },
    { label: "Why Nexora", path: "/about" },
    { label: "Contact", path: "/contact" },
  ],
  services: [
    { label: "AI Transformation", path: "/ai-transformation" },
    { label: "Services overview", path: "/services" },
    { label: "Industries", path: "/industries" },
  ],
  countries: COUNTRIES.map((c) => ({ label: `${c.flag}  ${c.name}`, path: c.path })),
};
